import api from '../../../api.js';

export const ActioneeEmission = {
  REWIND: api.internals.ns.emission('analytics', 'rewind')
};
